import { ScanSearch } from "lucide-react";
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { Badge } from "@/components/ui/badge";
import { useSearchEverywhere } from "./context";
import { SEARCH_EVERYWHERE_KBD_SHORTCUT } from "./SearchEverywhere";

export function SearchEverywhereTrigger() {
  const { setOpen } = useSearchEverywhere();

  return (
    <SidebarGroup>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton
            onClick={() => setOpen(true)}
            tooltip={{
              children: (
                <span className="flex items-center gap-2">
                  Quick Find
                  <Badge variant="secondary" className="py-0">
                    {SEARCH_EVERYWHERE_KBD_SHORTCUT}
                  </Badge>
                </span>
              ),
              side: "right",
            }}
          >
            <ScanSearch />
            <span className="truncate">Quick Find</span>
            <span className="ml-auto text-xs text-muted-foreground">
              {SEARCH_EVERYWHERE_KBD_SHORTCUT}
            </span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  );
}
